"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { createRef } from "react";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import classNames from "classnames";
import { observer } from "mobx-react";
import { action, observable } from "mobx";
var TruncatedText = /*#__PURE__*/function (_React$Component) {
  _inherits(TruncatedText, _React$Component);
  var _super = _createSuper(TruncatedText);
  function TruncatedText() {
    var _this;
    _classCallCheck(this, TruncatedText);
    _this = _super.apply(this, arguments);
    _this.displayText = "";
    _this.containerRef = createRef();
    _this.originalTextRef = createRef();
    _this.measureAvailableSpace = function () {
      var _a, _b;
      var text = _this.props.children;
      var separator = "...";
      var containerWidth = (_a = _this.containerRef.current) == null ? void 0 : _a.getBoundingClientRect().width;
      var originalTextWidth = (_b = _this.originalTextRef.current) == null ? void 0 : _b.getBoundingClientRect().width;
      if (!!containerWidth && !!originalTextWidth && text.length > separator.length && originalTextWidth > containerWidth) {
        var avgCharSize = originalTextWidth / text.length;
        var maxLength = Math.floor(containerWidth / avgCharSize);
        var sliceStart = Math.ceil((maxLength - separator.length) / 2);
        var sliceEnd = text.length - sliceStart;
        _this.displayText = "".concat(text.slice(0, sliceStart)).concat(separator).concat(text.slice(sliceEnd, text.length));
      } else {
        _this.displayText = text;
      }
    };
    return _this;
  }
  _createClass(TruncatedText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.measureAvailableSpace();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.children !== prevProps.children) {
        this.measureAvailableSpace();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children;
      return /* @__PURE__ */React.createElement(ReactResizeDetector, {
        handleWidth: true,
        handleHeight: false,
        onResize: this.measureAvailableSpace
      }, /* @__PURE__ */React.createElement("div", {
        className: "truncated-text",
        ref: this.containerRef
      }, /* @__PURE__ */React.createElement("div", {
        className: classNames("truncated-text__hidden-text", className),
        "aria-hidden": true,
        ref: this.originalTextRef
      }, children), /* @__PURE__ */React.createElement("div", {
        className: classNames("truncated-text__ghost-text", className),
        "aria-hidden": true
      }, children), /* @__PURE__ */React.createElement("div", {
        className: classNames("truncated-text__display-text", className)
      }, this.displayText)));
    }
  }]);
  return TruncatedText;
}(React.Component);
__decorateClass([observable.ref], TruncatedText.prototype, "displayText", 2);
__decorateClass([action], TruncatedText.prototype, "measureAvailableSpace", 2);
TruncatedText = __decorateClass([observer], TruncatedText);
export default TruncatedText;